/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Typography, Icon, Colors } from '@zapier/design-system';

type BackButtonProps = {
  /** Called when the button is clicked. */
  onClick: () => void;
};

const Styles = {
  button: css`
    ${Typography.paragraph3Bold}
    font-weight: 600;
    color: ${Colors.ocean};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-right: 10px;

    :hover,
    :focus {
      text-decoration: underline;
    }
  `,
};

/** Renders the back button used throughout the Get Help form. */
const BackButton = ({ onClick }: BackButtonProps) => (
  <button css={Styles.button} onClick={onClick} type="button">
    <Icon color="ocean" name="arrowSmallLeft" size={24} />
    Back
  </button>
);

export default BackButton;
